import * as React from 'react';
import './planet.scss';

interface IPlanet {
  place: number;
  sport: string;
  src: string;
}

const Planet: React.SFC<IPlanet> = ({ place, sport, src }) => {
  const scale = 1 - 0.1 * place;
  const scaleFactor = `scale(${scale}) translateX(-50%)`;
  const randomizer = () => {
    return Math.random() * (10 - 20) + 30;
  };
  return (
    <div className={'c-planet'} style={{ marginTop: randomizer() }}>
      <div className={'c-planet__wrapper'} style={{ transform: scaleFactor }}>
        <div
          className={`planet ${place}`}
          style={{ backgroundImage: `url(${src})` }}
        />
      </div>
      <div className="title">
        <span />
        <p>{sport}</p>
      </div>
    </div>
  );
};

export default Planet;



// WEBPACK FOOTER //
// ./src/containers/universe/components/Planet.tsx